import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Sidebar } from 'src/componentv2'
import { getNavItems } from 'src/app/dashboardv2/navConfig'
import { useSidebarUser } from 'src/app/dashboardv2/hooks/useSidebarUser'
import AuthApiContext from 'src/provider/API/v2/call-service/Auth'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'

export interface AppSidebarProps {
    activeKey: string
    variant?: 1 | null
    mobileOpen?: boolean
    onMobileClose?: () => void
}

export const AppSidebar: React.FC<AppSidebarProps> = ({ activeKey, variant = null, mobileOpen, onMobileClose }) => {
    const navigate = useNavigate()
    const navItems = getNavItems(navigate, variant)
    const user = useSidebarUser()
    const showHelp = variant !== 1
    const { logout: logoutRemote } = useContext(AuthApiContext)
    const { logout: clearLocalSession } = useContext(AppInfoContext)

    async function handleLogout() {
        await logoutRemote()
        await clearLocalSession()
    }

    return (
        <Sidebar
            navItems={navItems}
            activeKey={activeKey}
            user={user}
            showHelp={showHelp}
            onHelpClick={showHelp ? () => navigate('/dashboardv2/help-resources') : undefined}
            onViewProfile={() => navigate('/dashboardv2/profile')}
            onLogout={handleLogout}
            mobileOpen={mobileOpen}
            onMobileClose={onMobileClose}
        />
    )
}

export default AppSidebar
